/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetProviders200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { ProviderExtendedResponseModel } from '../models';
// @ts-ignore
import type { ProviderPatchModel } from '../models';
// @ts-ignore
import type { ProviderPostModel } from '../models';
// @ts-ignore
import type { ProviderSearchModel } from '../models';
/**
 * ProvidersApi - axios parameter creator
 * @export
 */
export const ProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API to delete/mark inactive
         * @summary delete a Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProvider: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('deleteProvider', 'providerId', providerId)
            const localVarPath = `/api/v1/provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to get Provider data
         * @summary get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider: async (providerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('getProvider', 'providerId', providerId)
            const localVarPath = `/api/v1/provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list Providers
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders: async (providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerSearchModel' is not null or undefined
            assertParamExists('getProviders', 'providerSearchModel', providerSearchModel)
            const localVarPath = `/api/v1/provider/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (allProviders !== undefined) {
                localVarQueryParameter['allProviders'] = allProviders;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to update status of Provider
         * @summary update Provider status
         * @param {string} providerId 
         * @param {ProviderPatchModel} providerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProvider: async (providerId: string, providerPatchModel: ProviderPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('patchProvider', 'providerId', providerId)
            // verify required parameter 'providerPatchModel' is not null or undefined
            assertParamExists('patchProvider', 'providerPatchModel', providerPatchModel)
            const localVarPath = `/api/v1/provider/{providerId}`
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to add a new Provider
         * @summary add a new Provider
         * @param {ProviderPostModel} providerPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProvider: async (providerPostModel: ProviderPostModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerPostModel' is not null or undefined
            assertParamExists('postProvider', 'providerPostModel', providerPostModel)
            const localVarPath = `/api/v1/provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(providerPostModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to validate the Provider
         * @summary validate Provider
         * @param {string} [npi] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProvider: async (npi?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/provider/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (npi !== undefined) {
                localVarQueryParameter['npi'] = npi;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * verify NPI and fetch npi details from npi registry api
         * @summary verify npi details
         * @param {string} npi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyNpi: async (npi: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'npi' is not null or undefined
            assertParamExists('verifyNpi', 'npi', npi)
            const localVarPath = `/api/v1/provider/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (npi !== undefined) {
                localVarQueryParameter['npi'] = npi;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProvidersApi - functional programming interface
 * @export
 */
export const ProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * API to delete/mark inactive
         * @summary delete a Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProvider(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProvider(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.deleteProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to get Provider data
         * @summary get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProvider(providerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderExtendedResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProvider(providerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.getProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list Providers
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProviders(providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProviders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProviders(providerSearchModel, allProviders, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.getProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to update status of Provider
         * @summary update Provider status
         * @param {string} providerId 
         * @param {ProviderPatchModel} providerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchProvider(providerId: string, providerPatchModel: ProviderPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchProvider(providerId, providerPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.patchProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to add a new Provider
         * @summary add a new Provider
         * @param {ProviderPostModel} providerPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postProvider(providerPostModel: ProviderPostModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postProvider(providerPostModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.postProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API to validate the Provider
         * @summary validate Provider
         * @param {string} [npi] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateProvider(npi?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateProvider(npi, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.validateProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * verify NPI and fetch npi details from npi registry api
         * @summary verify npi details
         * @param {string} npi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyNpi(npi: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyNpi(npi, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProvidersApi.verifyNpi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProvidersApi - factory interface
 * @export
 */
export const ProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProvidersApiFp(configuration)
    return {
        /**
         * API to delete/mark inactive
         * @summary delete a Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProvider(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProvider(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * API to get Provider data
         * @summary get Provider
         * @param {string} providerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderExtendedResponseModel> {
            return localVarFp.getProvider(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list Providers
         * @param {ProviderSearchModel} providerSearchModel 
         * @param {boolean} [allProviders] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProviders(providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetProviders200Response> {
            return localVarFp.getProviders(providerSearchModel, allProviders, pgNum, pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API to update status of Provider
         * @summary update Provider status
         * @param {string} providerId 
         * @param {ProviderPatchModel} providerPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProvider(providerId: string, providerPatchModel: ProviderPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchProvider(providerId, providerPatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to add a new Provider
         * @summary add a new Provider
         * @param {ProviderPostModel} providerPostModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postProvider(providerPostModel: ProviderPostModel, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.postProvider(providerPostModel, options).then((request) => request(axios, basePath));
        },
        /**
         * API to validate the Provider
         * @summary validate Provider
         * @param {string} [npi] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateProvider(npi?: string, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateProvider(npi, name, options).then((request) => request(axios, basePath));
        },
        /**
         * verify NPI and fetch npi details from npi registry api
         * @summary verify npi details
         * @param {string} npi 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyNpi(npi: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.verifyNpi(npi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProvidersApi - interface
 * @export
 * @interface ProvidersApi
 */
export interface ProvidersApiInterface {
    /**
     * API to delete/mark inactive
     * @summary delete a Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    deleteProvider(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to get Provider data
     * @summary get Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    getProvider(providerId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProviderExtendedResponseModel>;

    /**
     * 
     * @summary list Providers
     * @param {ProviderSearchModel} providerSearchModel 
     * @param {boolean} [allProviders] 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    getProviders(providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetProviders200Response>;

    /**
     * API to update status of Provider
     * @summary update Provider status
     * @param {string} providerId 
     * @param {ProviderPatchModel} providerPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    patchProvider(providerId: string, providerPatchModel: ProviderPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * API to add a new Provider
     * @summary add a new Provider
     * @param {ProviderPostModel} providerPostModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    postProvider(providerPostModel: ProviderPostModel, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * API to validate the Provider
     * @summary validate Provider
     * @param {string} [npi] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    validateProvider(npi?: string, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * verify NPI and fetch npi details from npi registry api
     * @summary verify npi details
     * @param {string} npi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApiInterface
     */
    verifyNpi(npi: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * ProvidersApi - object-oriented interface
 * @export
 * @class ProvidersApi
 * @extends {BaseAPI}
 */
export class ProvidersApi extends BaseAPI implements ProvidersApiInterface {
    /**
     * API to delete/mark inactive
     * @summary delete a Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public deleteProvider(providerId: string, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).deleteProvider(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to get Provider data
     * @summary get Provider
     * @param {string} providerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public getProvider(providerId: string, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).getProvider(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list Providers
     * @param {ProviderSearchModel} providerSearchModel 
     * @param {boolean} [allProviders] 
     * @param {number} [pgNum] 
     * @param {number} [pgSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public getProviders(providerSearchModel: ProviderSearchModel, allProviders?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).getProviders(providerSearchModel, allProviders, pgNum, pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to update status of Provider
     * @summary update Provider status
     * @param {string} providerId 
     * @param {ProviderPatchModel} providerPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public patchProvider(providerId: string, providerPatchModel: ProviderPatchModel, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).patchProvider(providerId, providerPatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to add a new Provider
     * @summary add a new Provider
     * @param {ProviderPostModel} providerPostModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public postProvider(providerPostModel: ProviderPostModel, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).postProvider(providerPostModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to validate the Provider
     * @summary validate Provider
     * @param {string} [npi] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public validateProvider(npi?: string, name?: string, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).validateProvider(npi, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * verify NPI and fetch npi details from npi registry api
     * @summary verify npi details
     * @param {string} npi 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProvidersApi
     */
    public verifyNpi(npi: string, options?: RawAxiosRequestConfig) {
        return ProvidersApiFp(this.configuration).verifyNpi(npi, options).then((request) => request(this.axios, this.basePath));
    }
}

